import { getApiBase } from "./apiBase";

/** POST /chat response when session is in human mode (no AI answer yet). */
export function isHumanQueuedChatResponse(data) {
  return data?.mode === "human" && (data.queued === true || !data.answer);
}

/**
 * Poll /live/student-inbox for human-agent replies (web/embed human mode).
 * Returns a stop function.
 */
export function startStudentInboxPoll({
  sessionId,
  onAgentMessage,
  onModeChange,
  intervalMs = 2000,
}) {
  if (!sessionId) return () => {};

  let lastSeen = null;
  let stopped = false;
  const seenIds = new Set();

  const poll = async () => {
    if (stopped || !sessionId) return;
    const base = getApiBase();
    if (!base) {
      console.warn("[live-inbox] REACT_APP_API_URL is not set");
      return;
    }
    try {
      const qs = lastSeen ? `?since=${encodeURIComponent(lastSeen)}` : "";
      const url = `${base}/live/student-inbox/${encodeURIComponent(sessionId)}${qs}`;
      const res = await fetch(url);
      if (!res.ok) {
        console.warn("[live-inbox] poll failed", res.status, sessionId);
        return;
      }
      const data = await res.json();
      if (data.mode && data.mode !== "human" && onModeChange) {
        onModeChange(data.mode);
      }
      for (const msg of data.messages || []) {
        if (msg.id && seenIds.has(msg.id)) continue;
        if (msg.id) seenIds.add(msg.id);
        if (msg.timestamp) {
          if (!lastSeen || msg.timestamp > lastSeen) {
            lastSeen = msg.timestamp;
          }
        }
        onAgentMessage(msg);
      }
    } catch (err) {
      console.warn("[live-inbox] poll error", err);
    }
  };

  const timer = setInterval(poll, intervalMs);
  poll();

  return () => {
    stopped = true;
    clearInterval(timer);
  };
}
